import { render, staticRenderFns } from "./SolanJournalsTableHeaderRow.vue?vue&type=template&id=2846a0c7&scoped=true&"
import script from "./SolanJournalsTableHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsTableHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsTableHeaderRow.vue?vue&type=style&index=0&id=2846a0c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846a0c7",
  null
  
)

export default component.exports